/*  MUI  */
import { Box, Typography } from '@mui/material';

/*  Shared  */
import { TooltipQ } from 'application/Shared/Components/Tooltips';

/* Yarn */
import i18n from 'i18n';

/* React */
import React from 'react';

const { t } = i18n;

export const StyleText = ({ style, text, tooltipText }) => (
    <Box as="span" display="flex" alignItems="center">
        <Typography variant="span" ml="2px" style={{ ...style }}>
            {t(text)}
        </Typography>
        {tooltipText && <TooltipQ placement="right" text={t(tooltipText)} />}
    </Box>
);
